import { Component, OnInit, OnDestroy } from '@angular/core';

import { untilDestroyed } from '@app/core';
import { User } from '@app/models';
import { UserService } from '@app/services';

@Component({
  selector: 'app-documents-group',
  templateUrl: './documents-group.component.html',
  styleUrls: ['./documents-group.component.scss'],
  standalone: false
})
export class DocumentsGroupComponent implements OnInit, OnDestroy {
  currentUser: User;

  constructor(private userService: UserService) {
    this.userService
      .watchCurrentUser()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: user => (this.currentUser = user)
      });
  }

  ngOnInit() {}

  ngOnDestroy() {}
}
